import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import UserComplaintContent from "modules/UserComplaint";

import React from "react";

import { setTitle } from "utilities/helper/setTitle";

const UserComplaintPage: React.FC = () => {
  setTitle("User Complaint");
  return (
    <Auth>
      <Layout>
        <UserComplaintContent />
      </Layout>
    </Auth>
  );
};

export default UserComplaintPage;
